<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Offer_statuses/elements/Title.vue'

export default {
  name: 'OfferStatusForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
